import { portalBaseUrl } from 'client/utils/constants/frontEndConfig';
export const HOME_PAGE = '/';
export const MAP_PAGE = '/map';
export const NETWORK_COVERAGE_PAGE = '/coverage';
export const MAP_PAGE_ENQUIRY = MAP_PAGE + '/enquiry';
export const MAP_PAGE_WORKPACK = MAP_PAGE + '/downloads';
export const BOOKMARKS_PAGE = '/bookmarks';

// PDFs generated before workpack/enquiry split will still use this route
// We can potentially remove this after a few months when all old PDFs have expired
// e.g. ~June 2026
export const LEGACY_ENQUIRIES_PAGE = '/enquiries';
export const LEGACY_VIEW_ENQUIRY_PAGE = LEGACY_ENQUIRIES_PAGE + '/view';
export const ENQUIRIES_PAGE = '/enquiry';
export const CREATE_ENQUIRY_PAGE = ENQUIRIES_PAGE + '/create';
export const VIEW_ENQUIRY_PAGE = ENQUIRIES_PAGE + '/view';

export const WORKPACKS_PAGE = '/downloads';
export const CREATE_WORKPACK_PAGE = WORKPACKS_PAGE + '/create';
export const VIEW_WORKPACK_PAGE = WORKPACKS_PAGE + '/view';
export const PRIVACY_PAGE = '/privacy';
export const COOKIES_PAGE = '/cookies';
export const CONTACT_PAGE_SIGNED_OUT = '/contact-signed-out';
export const CONTACT_PAGE = '/contact';
export const TERMS_AND_CONDITIONS_PAGE = '/terms';
export const REAFFIRMATION_PAGE = '/reaffirmation';
export const HELP_PAGE_SIGNED_OUT = '/help-signed-out';
export const HELP_PAGE = '/help';
export const HELP_PAGE_CONTENT = '/help-content/:contentKey';
export const HSG47_PAGE = '/hsg47';
export const PLATFORM_NOTICES_PAGE = '/platform-notices';
export const NEWS_PAGE = '/news';
export const RELEASE_NOTES = '/news-page/release-notes';
export const WORKING_ON = '/news-page/what-working-on';
export const NEWS_PAGE_CONTENT = '/news-page/:contentKey';
export const NO_ORGANISATIONS_PAGE = '/no-organisations';
export const SERVICE_UNAVAILABLE_PAGE = '/service-unavailable';
export const USER_PROFILE_NOT_FOUND_PAGE = '/user-profile-not-found';
export const LOGGED_OUT_PARAM = 'loggedout';
export const OBSERVATIONS_PAGE = '/observations';
export const SAVE_OBSERVATION_PAGE = OBSERVATIONS_PAGE + '/save';
export const VIEW_OBSERVATION_PAGE = OBSERVATIONS_PAGE + '/view';
export const FEEDBACK_PAGE = '/feedback';
export const CMS_MEDIA_LOADER_URL = '/media';
export const LICENSE_URL = 'https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/';
export const COPYRIGHT_URL = 'https://www.nationalarchives.gov.uk/information-management/re-using-public-sector-information/uk-government-licensing-framework/crown-copyright/';
export const FEEDBACK_URL = portalBaseUrl + FEEDBACK_PAGE;

export default {
    HOME_PAGE,
    MAP_PAGE,
    CMS_MEDIA_LOADER_URL,
    NETWORK_COVERAGE_PAGE,
    MAP_PAGE_ENQUIRY,
    MAP_PAGE_WORKPACK,
    BOOKMARKS_PAGE,
    ENQUIRIES_PAGE,
    CREATE_ENQUIRY_PAGE,
    VIEW_ENQUIRY_PAGE,
    WORKPACKS_PAGE,
    CREATE_WORKPACK_PAGE,
    VIEW_WORKPACK_PAGE,
    PRIVACY_PAGE,
    COOKIES_PAGE,
    CONTACT_PAGE_SIGNED_OUT,
    CONTACT_PAGE,
    TERMS_AND_CONDITIONS_PAGE,
    HELP_PAGE_SIGNED_OUT,
    HELP_PAGE,
    HELP_PAGE_CONTENT,
    HSG47_PAGE,
    NEWS_PAGE,
    NEWS_PAGE_CONTENT,
    NO_ORGANISATIONS_PAGE,
    SERVICE_UNAVAILABLE_PAGE,
    LOGGED_OUT_PARAM,
    OBSERVATIONS_PAGE,
    SAVE_OBSERVATION_PAGE,
    VIEW_OBSERVATION_PAGE,
    LICENSE_URL,
    COPYRIGHT_URL,
    FEEDBACK_URL,
    FEEDBACK_PAGE
};
